import CircleLoader from "@components/loader/CircleLoader";

export default function Loader(props) {
  const {
    type = "circle",
  } = props;

  switch (type) {
  case "circle":
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center">
        <CircleLoader {...props} />
      </div>
    );
  default:
    return null;
  }
}
